export default function SoftBreak(options = {}) {
  return {
    onKeyDown(event, editor, next) {
      if (event.key !== "Enter") return next()
      if (options.shift && event.shiftKey === false) return next()
      return editor.insertText("\n")
    }
  }
}
